<!--suppress JSUnresolvedReference -->
<template>
    <ClientOnly>
        <div></div>
    </ClientOnly>
</template>

<script setup>
import { onMounted } from 'vue'

onMounted(() => {
    const script = document.createElement('script')
    script.src = "https://plugin.handtalk.me/web/latest/handtalk.min.js"
    script.onload = () => {
        new HT({
            token: "6470e7190f4602025cd0c52d604a58b7",
            maxTextSize: 1000,
            side: 'left',
            avatar: "MAYA"
        })
    }
    document.body.appendChild(script)
})
</script>
